<div class="admin-content">
  <cei-admin-page-cabecalho titulo="Detalhes do Usuário" [rotaVoltar]="'/admin/pessoas'" />
  @if (usuario(); as usuario) {
    <cei-panel class="admin-form-panel" [height]="'auto'">
      <table class="admin-detail-table">
        <tbody>
          <tr>
            <th scope="row">ID</th>
            <td>{{ usuario.id }}</td>
          </tr>
          <tr>
            <th scope="row">Login</th>
            <td>{{ usuario.login }}</td>
          </tr>
          <tr>
            <th scope="row">Email</th>
            <td>{{ usuario.email }}</td>
          </tr>
          <tr>
            <th scope="row">Ativo</th>
            <td>{{ usuario.is_active ? 'Sim' : 'Não' }}</td>
          </tr>
          <tr>
            <th scope="row">Staff</th>
            <td>{{ usuario.is_staff ? 'Sim' : 'Não' }}</td>
          </tr>
          <tr>
            <th scope="row">Permissões</th>
            <td>
              @if (usuario.user_permissions.length) {
                <ul class="admin-detail-list">
                  @for (permission of usuario.user_permissions; track permission.id) {
                    <li>{{ permission.name }} ({{ permission.codename }})</li>
                  }
                </ul>
              } @else {
                Nenhuma permissão vinculada.
              }
            </td>
          </tr>
          <tr>
            <th scope="row">Grupos</th>
            <td>
              @if (usuario.groups.length) {
                <ul class="admin-detail-list">
                  @for (group of usuario.groups; track group.id) {
                    <li>{{ group.name }}</li>
                  }
                </ul>
              } @else {
                Nenhum grupo vinculado.
              }
            </td>
          </tr>
        </tbody>
      </table>
    </cei-panel>
    <div class="admin-content__actions" [routerLink]="['/admin/pessoas/atualizar', usuario.id]">
      <cei-button type="button">Editar</cei-button>
    </div>
  }
</div>
